import React, { FC, memo, useCallback, useMemo } from 'react'
import { Chips } from '@ucheba/ui/components/Chips/desktop'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import styled from 'styled-components'
import { stringifyUrl } from '@ucheba/utils/helpers/router'
import { Button } from '@ucheba/ui/components/Button/desktop'
import { useRouter } from 'next/router'
import { ESpecialitiesDataKeys } from '@ucheba/store/specialities/search/types'
import { specialitiesSearchSelectors } from '@ucheba/store/specialities/search'
import { useSelector } from 'react-redux'
import { useSpecialitiesPageSelectedFacets } from '../bll'
import { ISpecialitiesSearchPageSelectedFacetsProps } from '../types'

const Block = styled.div`
  margin-bottom: -${sv.spacing.xsmall};
`
const Chip = styled(Chips)`
  margin-right: ${sv.spacing.xsmall};
  margin-bottom: ${sv.spacing.xsmall};
`

const SpecialitiesSearchPageSelectedFacets: FC<
  ISpecialitiesSearchPageSelectedFacetsProps
> = (props) => {
  const { facetsState } = props
  const { selectedFacets, removeFacet } = useSpecialitiesPageSelectedFacets(facetsState)

  const criteria = useSelector(specialitiesSearchSelectors.criteria)

  const onRemoveFacet = (queryKey, id) => () => removeFacet(queryKey, id)

  const router = useRouter()

  const params = useMemo(() => {
    const { query } = router

    const result = {} as Record<string, any>

    if (criteria && criteria.topProgramTypes) {
      result.topProgramTypes = criteria.topProgramTypes.map((el) => {
        return String(el.value)
      })
    }

    Object.keys(query).forEach((key) => {
      if (key !== 'params') {
        const facetName = key.replace(/[[]]/gm, '')

        if (key.includes('[]')) {
          result[facetName] = Array.isArray(query[key]) ? query[key] : [query[key]]
        } else {
          result[facetName] = query[key]
        }
      }
    })

    return result
  }, [criteria, router])

  const resetFacets = useCallback(() => {
    router.push(
      stringifyUrl('/for-abiturients/speciality/search', {
        exclude: [
          ESpecialitiesDataKeys.examSubjectIds,
          ESpecialitiesDataKeys.tagIds,
          ESpecialitiesDataKeys.locationIds,
          ESpecialitiesDataKeys.trainingFormTypes,
          ESpecialitiesDataKeys.programTypes,
        ],
        set: { ...params },
      }),
      undefined,
      {
        shallow: true,
      }
    )
  }, [router, params])

  if (!selectedFacets.length) return null

  return (
    <Block>
      {selectedFacets.map(({ name, value, queryKey }) => (
        <Chip
          color='blue'
          clear
          onClick={onRemoveFacet(queryKey, value)}
          firstLetterUppercase
          key={queryKey + value}
        >
          {name}
        </Chip>
      ))}

      {selectedFacets.length > 2 && (
        <Button size='small' view='link' onClick={resetFacets}>
          Сбросить все фильтры
        </Button>
      )}

      <Spacing spacing='xlarge' />
    </Block>
  )
}

export default memo(SpecialitiesSearchPageSelectedFacets)
